import script from "./illegalUnits.vue?vue&type=script&setup=true&lang=js"
export * from "./illegalUnits.vue?vue&type=script&setup=true&lang=js"

import "./illegalUnits.vue?vue&type=style&index=0&id=31ef462e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ef462e"]])

export default __exports__